module.exports = __webpack_public_path__ + "75ef09dfe212263cecc99c751b8c2e16.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../images/speakers/small/nicole-chung.jpg
// module id = 674
// module chunks = 0